import { elarianDialogues } from './elarian/dialogues.js';
import { goblinForestDialogues } from './goblinForest/dialogues.js';
import { mirewoodDialogues } from './mirewood/dialogues.js';

const dialogues = { ...elarianDialogues, ...goblinForestDialogues, ...mirewoodDialogues };

export { dialogues };
